import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const CrossIcon = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      fill="#000"
      d="M5.768 19 5 18.232 11.232 12 5 5.768 5.768 5 12 11.232 18.232 5l.768.768L12.768 12 19 18.232l-.768.768L12 12.768 5.768 19Z"
    />
  </Svg>
);
export default CrossIcon;
